var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Logo_bk-logo-strap",
    width: 189.259,
    height: 21.65,
    "data-name": "Logo/bk-logo-strap",
    viewBox: "0 0 189.259 21.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_18",
    d: "M10.658 20.42A1.991 1.991 0 0 0 8.4 18.171H6.611v4.5h1.853a1.966 1.966 0 0 0 2.194-2.251zm-.433-8.12a1.771 1.771 0 0 0-2.009-2H6.611v4.013H8.28a1.747 1.747 0 0 0 1.945-2.013zm6.547 8.461q0 6.177-6.547 6.18H.5V6.1h9.26c4.159 0 6.24 1.65 6.24 4.966a4.645 4.645 0 0 1-2.5 4.543 5.34 5.34 0 0 1 3.272 5.153z",
    className: "prefix__cls-1",
    "data-name": "Path 18",
    transform: "translate(-.497 -5.476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_19",
    d: "M162.62 21.293a4.7 4.7 0 0 1-2.506 4.372 12.1 12.1 0 0 1-11.413 0 4.7 4.7 0 0 1-2.51-4.372V6.105h3.059q3.058 0 3.057 2.684V20.4q0 1.758 2.1 1.76t2.1-1.76V6.105h3.056c2.042 0 3.056.892 3.056 2.684z",
    className: "prefix__cls-1",
    "data-name": "Path 19",
    transform: "translate(-128.392 -5.48)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_20",
    d: "M304.721 10.3v4.752h1.758q2.6 0 2.595-2.378t-2.595-2.374zm6.7 7.778l2.78 3.8a3.741 3.741 0 0 1 1.083 2.434 2.677 2.677 0 0 1-1.106 1.953 3.313 3.313 0 0 1-2.233.826 3.485 3.485 0 0 1-2.393-1.445l-4.831-6.606v5.21q0 2.691-3.059 2.693h-3.055V6.1h9.973a5.371 5.371 0 0 1 4.26 1.963 6.348 6.348 0 0 1 1.7 4.222 6.128 6.128 0 0 1-3.119 5.792z",
    className: "prefix__cls-1",
    "data-name": "Path 20",
    transform: "translate(-262.186 -5.477)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_21",
    d: "M458.329 9.665v8.455a3.765 3.765 0 0 1-2.036 3.214q-2.039 1.3-6.686 1.3a10.719 10.719 0 0 1-7.751-2.992 10.358 10.358 0 0 1-3.1-7.82 10.438 10.438 0 0 1 3.087-7.831 10.264 10.264 0 0 1 7.419-3.007 12.973 12.973 0 0 1 6.591 1.358q2.261 1.362 2.3 2.55a3.026 3.026 0 0 1-.782 2.123 2.215 2.215 0 0 1-1.589.937 5.729 5.729 0 0 1-2.256-.748 8.943 8.943 0 0 0-3.959-.781 4.285 4.285 0 0 0-3.682 1.517 6.2 6.2 0 0 0-1.2 3.892 5.641 5.641 0 0 0 1.328 3.856 4.381 4.381 0 0 0 3.522 1.483c1.458-.023 2.375-.235 2.746-.649v-1.674h-.958q-2.776 0-2.777-2.591V9.665z",
    className: "prefix__cls-1",
    "data-name": "Path 21",
    transform: "translate(-385.211 -.984)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_22",
    d: "M616.215 26.944V6.1h12.846v2.455A2.131 2.131 0 0 1 626.685 11h-4.355v3h6.115v2.475q0 2.469-2.378 2.472h-3.737v3.085h6.731v2.457a2.135 2.135 0 0 1-2.375 2.455z",
    className: "prefix__cls-1",
    "data-name": "Path 22",
    transform: "translate(-540.992 -5.477)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_23",
    d: "M744.114 10.3v4.752h1.759q2.6 0 2.593-2.378t-2.593-2.374zm6.7 7.778l2.777 3.8a3.713 3.713 0 0 1 1.082 2.434 2.658 2.658 0 0 1-1.105 1.953 3.318 3.318 0 0 1-2.234.826 3.491 3.491 0 0 1-2.391-1.445l-4.83-6.606v5.21q0 2.691-3.061 2.693H738V6.1h9.973a5.366 5.366 0 0 1 4.26 1.963 6.357 6.357 0 0 1 1.7 4.222 6.133 6.133 0 0 1-3.117 5.792z",
    className: "prefix__cls-1",
    "data-name": "Path 23",
    transform: "translate(-647.897 -5.477)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_24",
    d: "M958.674 14.823l4.877 5.555a3.149 3.149 0 0 1 1 2.283 3.01 3.01 0 0 1-1.107 2 2.783 2.783 0 0 1-2.266.773 3.491 3.491 0 0 1-2.264-1.424l-5.9-6.55v5.14q0 2.684-3.058 2.682H946.9V4.459h6.113v7.756l5.9-6.525a3.5 3.5 0 0 1 2.264-1.432 2.763 2.763 0 0 1 2.252.76 2.978 2.978 0 0 1 1.1 2.016 3.1 3.1 0 0 1-.986 2.265z",
    className: "prefix__cls-1",
    "data-name": "Path 24",
    transform: "translate(-831.282 -3.838)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_25",
    d: "M1109.332 24.254q0 2.69-3.055 2.693h-3.057V8.789q0-2.687 3.057-2.684h3.055z",
    className: "prefix__cls-1",
    "data-name": "Path 25",
    transform: "translate(-968.498 -5.479)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_26",
    d: "M1184.118 15.389v-6.6q0-2.689 3.058-2.685h3.061v18.145q0 2.69-3.061 2.693a3.325 3.325 0 0 1-2.684-1.178l-6.857-8.153v6.638q0 2.69-3.055 2.693h-3.06V6.111l3.06-.011a3.077 3.077 0 0 1 2.81 1.26z",
    className: "prefix__cls-1",
    "data-name": "Path 26",
    transform: "translate(-1028.454 -5.475)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_27",
    d: "M1356.724 9.665v8.455a3.761 3.761 0 0 1-2.036 3.214q-2.04 1.3-6.684 1.3a10.722 10.722 0 0 1-7.752-2.992 10.354 10.354 0 0 1-3.1-7.82 10.44 10.44 0 0 1 3.084-7.831 10.271 10.271 0 0 1 7.421-3.007 12.977 12.977 0 0 1 6.593 1.358q2.26 1.362 2.294 2.55a3.02 3.02 0 0 1-.782 2.123 2.218 2.218 0 0 1-1.588.937 5.714 5.714 0 0 1-2.255-.748 8.95 8.95 0 0 0-3.962-.781 4.278 4.278 0 0 0-3.68 1.517 6.184 6.184 0 0 0-1.2 3.892 5.635 5.635 0 0 0 1.33 3.856 4.38 4.38 0 0 0 3.522 1.483c1.461-.023 2.376-.235 2.745-.649v-1.674h-.955q-2.782 0-2.784-2.591V9.665z",
    className: "prefix__cls-1",
    "data-name": "Path 27",
    transform: "translate(-1173.849 -.984)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_28",
    d: "M1512.212 2.873h.475c.263 0 .579.046.579.355 0 .345-.237.389-.552.389h-.5zm-.547 2.384h.547V4.049h.355l.691 1.208h.578l-.752-1.232a.7.7 0 0 0 .743-.752c0-.617-.4-.833-1.1-.833h-1.058zm-.971-1.432a1.969 1.969 0 1 1 3.937 0 1.97 1.97 0 1 1-3.937 0zm-.434 0a2.4 2.4 0 1 0 2.408-2.382 2.382 2.382 0 0 0-2.408 2.381z",
    className: "prefix__cls-1",
    "data-name": "Path 28",
    transform: "translate(-1325.809 -1.387)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBk);
export default __webpack_public_path__ + "static/media/logo-bk.6ccfd3d7b81fb82954a4e879aee6bc03.svg";
export { ForwardRef as ReactComponent };